export const emojisMap: Map<string, [string, string]> = new Map([
    [':)', ['', '🙂']],
    [':D', ['', '😀']],
    [':(', ['', '🙁']],
    [';)', ['', '😉']],
    ['<3', ['', '❤']],
    ['🙂', ['', '🙂']],
    ['😀', ['', '😀']],
    ['🙁', ['', '🙁']],
    ['❤', ['', '❤']]
]);
